<div class="smi-container" role="main">
    <smione-loading-screen></smione-loading-screen>
  <router-outlet></router-outlet>
</div>
<div *ngIf="!isConnected" class="alert-noiternet">
<div class="alert alert-danger fade show" role="alert">
  <strong> {{'AppComponent.NoInternet' | translate}} </strong>
</div>
</div>